// This is a copy of the FeaturedImage component used in ContentPageHeader currency component
// https://github.com/NerdWallet/currency/blob/master/src/components/ContentPageHeader/FeaturedImage.tsx

import React from 'react';

import baseStyles from '@nerdwallet/base-styles/react';
import Image from '@nerdwallet/react-image';

/**
 * Return a MediaItem object with sizes filtered by a given array of size labels
 *
 * @param mediaItem - query0 MediaItem object
 * @param sizes - Array of media sizes to return
 */
const filterMediaSizes = (mediaItem: MediaItem, sizes: string[]): MediaItem => {
  if (!mediaItem?.mediaDetails?.sizes?.length) return mediaItem;
  return {
    ...mediaItem,
    mediaDetails: {
      ...mediaItem.mediaDetails,
      sizes: mediaItem.mediaDetails.sizes.filter(({ size }) =>
        sizes.includes(size)
      ),
    },
  };
};

/**
 * Get a `srcSet` containing all the images at the same ratio of a given image size.
 *
 * @param mediaItem - query0 MediaItem object.
 *
 * @return a `srcSet` string.
 */
const getMediaSrcSetGql = (mediaItem: MediaItem): string => {
  if (!mediaItem?.mediaDetails?.sizes?.length) return '';

  return mediaItem.mediaDetails.sizes
    .sort((a, b) => a.width - b.width)
    .map((currSize) => {
      const srcUrl = currSize?.sourceUrl;
      const width = currSize?.width;
      return `${srcUrl} ${width}w`;
    })
    .join(', ');
};

export interface MediaItem {
  altText?: string;
  mediaDetails?: {
    sizes?: {
      sourceUrl: string;
      width: number;
      height: number;
      size: string;
    }[];
  };
}

export interface FeaturedImageProps {
  data: MediaItem;
  hideOnMobile?: boolean;
}

export const LendingFeaturedImage: React.FC<FeaturedImageProps> = ({
  data,
  hideOnMobile,
}) => {
  const featuredImageInfo = filterMediaSizes(data, ['primary-l', 'primary-m'])
    ?.mediaDetails?.sizes?.[0];

  const featuredImageSrcSet = getMediaSrcSetGql(
    filterMediaSizes(data, [
      'primary-xxxl',
      'primary-xxl',
      'primary-xl',
      'primary-l',
      'primary-m',
    ])
  );

  if (!(featuredImageSrcSet && featuredImageInfo)) {
    return null;
  }

  return (
    <div
      {...baseStyles({
        'display-none': hideOnMobile,
        'display-block--wide': hideOnMobile,
      })}
    >
      <Image
        alt={data.altText || ''}
        aspectRatio="10:4"
        src={featuredImageInfo.sourceUrl}
        srcSet={featuredImageSrcSet}
      />
    </div>
  );
};
